import { Faq } from "@cryptors/api-client";
import { Box, TextField } from "@mui/material";
import { HttpError, IResourceComponentsProps } from "@refinedev/core";
import { Create } from "@refinedev/mui";
import { useForm } from "@refinedev/react-hook-form";
import { Controller } from "react-hook-form";

import FaqQuestions, { FaqQuestion } from "./FaqQuestions";

interface FaqFormValues {
  name?: string;
  nameTranslation?: { value: string };
  faqQuestions: FaqQuestion[];
}

export const FaqCreate: React.FC<IResourceComponentsProps> = () => {
  const {
    control,
    refineCore: { formLoading, onFinish },
    register,
    formState: { errors, isDirty, isValid },
    handleSubmit,
  } = useForm<Faq, HttpError, FaqFormValues>();

  const onFinishHandler = (data: FaqFormValues) => {
    onFinish({
      nameTranslation: { value: data.name ?? "" },
      faqQuestions: data.faqQuestions.map((faqQuestion) => ({
        questionTranslation: { value: faqQuestion.question ?? "" },
        answerTranslation: { value: faqQuestion.answer ?? "" },
      })),
    });
  };

  register("faqQuestions");

  return (
    <Create
      isLoading={formLoading}
      saveButtonProps={{
        onClick: handleSubmit(onFinishHandler),
        disabled: !isDirty || !isValid,
      }}
    >
      <Box
        component="form"
        sx={{ display: "flex", flexDirection: "column" }}
        autoComplete="off"
      >
        <TextField
          {...register("name", {
            required: "Ce champ est requis",
          })}
          error={!!errors.name}
          helperText={errors.name?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Nom"
          name="name"
        />
        <Controller
          control={control}
          name="faqQuestions"
          defaultValue={[]}
          rules={{
            required: "Ce champ est requis",
            validate: (value: FaqQuestion[]) =>
              value.every((el) => el.answer && el.question),
          }}
          render={({ field }) => (
            <FaqQuestions
              faqQuestions={field.value}
              setValue={(value) => field.onChange(value)}
            />
          )}
        />
      </Box>
    </Create>
  );
};
